import React, { Component } from "react";
import Form from "./Form/Form";
import Form2 from "./Form2/Form2";
import Form3 from "./Form3/Form3";
import Onboarding from "./Onboarding/Onboarding";
import "./SignUp.css";

class SignUp extends Component {
	render() {
		let step = this.props.onboardingStepBuyer;
		return (
			<div className="container">
				{step === 0 && (
					<Form
						trianglify={this.props.trianglify}
						onboardingStepBuyer={this.props.onboardingStepBuyer}
						onboardingFlowBuyer={this.props.onboardingFlowBuyer}
						nextOnboardingBuyer={this.props.nextOnboardingBuyer}
						backOnboardingBuyer={this.props.backOnboardingBuyer}
						signUpParamsBuyer={this.props.signUpParamsBuyer}
						onChangeInput={this.props.onChangeInput}
					/>
				)}
				{step === 1 && (
					<Form2
						trianglify={this.props.trianglify}
						onboardingStepBuyer={this.props.onboardingStepBuyer}
						onboardingFlowBuyer={this.props.onboardingFlowBuyer}
						nextOnboardingBuyer={this.props.nextOnboardingBuyer}
						backOnboardingBuyer={this.props.backOnboardingBuyer}
						signUpParamsBuyer={this.props.signUpParamsBuyer}
						onChangeInput={this.props.onChangeInput}
					/>
				)}
				{step === 2 && (
					<Form3
						trianglify={this.props.trianglify}
						onboardingStepBuyer={this.props.onboardingStepBuyer}
						onboardingFlowBuyer={this.props.onboardingFlowBuyer}
						nextOnboardingBuyer={this.props.nextOnboardingBuyer}
						backOnboardingBuyer={this.props.backOnboardingBuyer}
						signUpParamsBuyer={this.props.signUpParamsBuyer}
						onChangeInput={this.props.onChangeInput}
					/>
				)}
				{step > 2 && (
					<Onboarding
						signUpParamsBuyer={this.props.signUpParamsBuyer}
						onboardingStepBuyer={this.props.onboardingStepBuyer}
						onboardingFlowBuyer={this.props.onboardingFlowBuyer}
						getSignUpProductTotalBuyer={this.props.getSignUpProductTotalBuyer}
						nextOnboardingBuyer={this.props.nextOnboardingBuyer}
						backOnboardingBuyer={this.props.backOnboardingBuyer}
						onTokenBuyer={this.props.onTokenBuyer}
					/>
				)}
			</div>
		);
	}
}

export default SignUp;


// WEBPACK FOOTER //
// ./src/components/BuyerList/SignUp.js